import React from 'react'
import dateFns from 'date-fns'
import { intervalify, totalForUsersToDollars } from '../utils'
import { CouponLabel } from '../components'

export default function CurrentPlanDetail({
  activeUsersCount,
  plan,
  subscription,
  organization,
  coupon,
}) {
  return (
    <div className="radius-normal border-small border-shade-40 padding-large line-height-larger">
      <div className="margin-bottom-medium">
        <span className="font-size-largest font-weight-bold shade-05">
          {totalForUsersToDollars(plan.amount, activeUsersCount)}
        </span>
        <span className="shade-20">/ {plan.interval}</span>
      </div>
      <div className="font-weight-bold margin-bottom-smaller">
        Your team is billed {intervalify(plan.interval)}.
      </div>
      {subscription.canceledAt ? (
        <div className="shade-20">
          You cancelled the current{' '}
          <span className="capitalize">{organization.product}</span> plan. Your
          team will be downgraded to the Free plan and no longer billed starting{' '}
          <span className="font-weight-bold">
            {dateFns.format(subscription.currentPeriodEnd, 'MMMM Do, YYYY')}
          </span>
          .
        </div>
      ) : (
        <div className="shade-20">
          Your plan will automatically renew on{' '}
          <span className="font-weight-bold">
            {dateFns.format(subscription.currentPeriodEnd, 'MMMM Do, YYYY')}
          </span>
          .
        </div>
      )}
      {coupon && (
        <div className="margin-top-normal">
          <CouponLabel coupon={coupon} />
        </div>
      )}
    </div>
  )
}
